export default class TestModule {
    constructor(element) {
      this.el = element
      this.buildpages = this.buildpages.bind(this)
      this.fetchdata = this.fetchdata.bind(this)
      this.previous = this.el.querySelectorAll(".previous")
      this.next = this.el.querySelectorAll(".next")
      this.retry = this.el.querySelector(".retry")
      this.testcontainer = this.el.querySelector(".test-container")
      this.previousslide = this.previousslide.bind(this)
      this.nextslide = this.nextslide.bind(this)
      this.calculateResult = this.calculateResult.bind(this)
      this.init()
    }
  
    init() {
		
        this.fetchdata()
        
    }

    fetchdata() {
		
		
		var url ="/api/quizapi/getquizbyidlang";
		
				
	var formData = {
		"id" : this.el.querySelector("#pageiden").value,
		"lang" : this.el.querySelector("#pagelang").value
	};
		
		
        fetch(url, {
            method: "Post",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json"
            },
			body: JSON.stringify(formData)			
			
        })
        .then(response => {
            return response.json();
        })
        .then(json => {
            
            this.buildpages(json)
            
        })
        .catch(e => { });
    }
    buildpages(json) {
       
	   var nextlbl = this.el.querySelector("#lblnext").value;
		var backlbl = this.el.querySelector("#lblback").value;
		var aflbl = this.el.querySelector("#lblaf").value;
		var questionlbl = this.el.querySelector("#lblquestion").value;
	   var tryagainLbl = this.el.querySelector("#lbltryagain").value;
	   
        const htmltemplate = json.quizasjson.Questions
        .map((item, index) => {
            let indexnumber = index
			
            return `
            <div class="question right" data-counter="${index+1}">
		<p>${questionlbl} ${index+1} ${aflbl} ${json.quizasjson.Questions.length}</p>
            <h2>${item.QuestionText}
            </h2>
            <radiogroup tabindex="0" aria-labelledby="${item.QuestionText}">
            <ul>${item.Answers.map((question, index) => `
            <label for="question-${index}-${indexnumber}" aria-label="${question.AnswerText}">
            <input class="radiobutton" id="question-${index}-${indexnumber}" name="Answer-${indexnumber}" type="radio" value="${question.Points}">
            <span role="button"></span>
            <p class="label">${question.AnswerText}</p>
            
            </label>`).join("")}</ul>
            </radiogroup>
            <button class="previous" data-present="${index+1}" data-previous="${index}">${backlbl}</button>
		<button class="next" disabled data-present="${index+1}" data-next="${index+2}">${nextlbl}</button>
            </div>
            
            `;
        })
        .join("");
		
		
		const startslide = `
            <div class="question center" data-counter="0">
            <h2>${json.quizasjson.Intro.Title}</h2>
            <p>${json.quizasjson.Intro.Description}</p>
            <button class="next" data-next="1" data-present="0">${nextlbl}</button>
            </div>
			
            `


        this.testcontainer.innerHTML = startslide + htmltemplate;
        
        let radiobuttons = this.el.querySelectorAll(".radiobutton");

        radiobuttons.forEach(radio =>{
            radio.addEventListener("change", event =>{
                let thisBox = radio.closest(".question");
                let thisNextButton = thisBox.querySelector(".next")
                thisNextButton.disabled = false;
                
            })
        })
        
        let next = this.el.querySelectorAll(".next")        
        let previous = this.el.querySelectorAll(".previous")
        let current = this.el.querySelector("[data-counter='0']")
        
		var count = 0;
		
        current.style.display = "block"
        next.forEach(button => {
            button.addEventListener("click", event =>{
                count = count +1;
				
				//console.log("json.quizasjson.Questions.length " + json.quizasjson.Questions.length)
				//console.log("button.dataset.present " + button.dataset.present)
				//console.log("current score: " + this.calculateResult(radiobuttons))
				//console.log(tryagainLbl)
				//console.log("count: " + count)
                if (json.quizasjson.Questions.length == button.dataset.present) {
				
					var numOf = json.quizasjson.Questions.length +1;
				
                    let score = this.calculateResult(radiobuttons)
                    //console.log("before showresults")
                    const showresults = json.quizasjson.Results
                    .filter(item => score >= item.RangeFrom && score <= item.RangeTo).map(item => {
                        return`
                        <div class="question right" data-counter="${numOf}">
                        <h2>${item.Title}</h2>
                        <p>${item.Infomation}</p>
                        <button class="retry">${tryagainLbl}</button>
                        </div>
                        `;
                    })
                    .join("");
                    
					//console.log("json.quizasjson.Results " + json.quizasjson.Results.length)
					//console.log("showresults "  + showresults.length)
					
                    this.testcontainer.innerHTML = this.testcontainer.innerHTML + showresults
                    
                    setTimeout(() => this.nextslide(button.dataset.next, button.dataset.present), 300)

                    let retry = this.el.querySelector(".retry")

					//console.log("retry: " + retry)

					var datacounterstring = "[data-counter='" + numOf+ "']"

                    retry.addEventListener("click", event => {
						
                        radiobuttons.forEach(radbutton => {
                            radbutton.checked = false;
                            
                            let centerSlide = document.querySelector("[data-counter='0']");
                            let alignRightSlide = document.querySelector(datacounterstring);

                            setTimeout(function(){
                            centerSlide.classList.remove("left");
                            centerSlide.classList.add("center");

                            alignRightSlide.classList.remove("center");
                            alignRightSlide.classList.add("right");
                            }, 400)
                            
                            
                            //console.log('radbutton.checked: ', radbutton.checked);
                        })
                        setTimeout(() => this.init(), 300)
                        
                    })
                    
                    
                }else{
                    this.nextslide(button.dataset.next, button.dataset.present)
                }

                
            })
        })

        previous.forEach(button => {
            button.addEventListener("click", event => {
                this.previousslide(button.dataset.previous, button.dataset.present)
            })
        })
        
    }
    nextslide(nextId, presentId) {

        let thisSlide = document.querySelector("[data-counter='"+presentId+"']");
        let nextSlide = document.querySelector("[data-counter='"+ nextId +"']");
        
		//console.log("presentId: " + presentId)
		//console.log("nextid: " + nextId)
		
        nextSlide.style.display = "block"
        setTimeout(function(){
            thisSlide.style.display = "none"
        }, 400)
        setTimeout(function(){ thisSlide.classList.add("left");
        thisSlide.classList.remove("center");
        nextSlide.classList.add("center");
        nextSlide.classList.remove("right"); }, 50);
      
        
    }
    
    previousslide(previousId, presentId) {
        let thisSlide = document.querySelector("[data-counter='"+presentId+"']");
        let previousSlide = document.querySelector("[data-counter='"+ previousId +"']");
        
        previousSlide.style.display = "block"
        setTimeout(function(){
            thisSlide.style.display = "none"
        }, 400)
        setTimeout(function(){ thisSlide.classList.add("right");
        thisSlide.classList.remove("center");
        previousSlide.classList.add("center");
        previousSlide.classList.remove("left"); }, 50);

        
    }
    calculateResult(radiobuttons) {
        let score = 0;
        radiobuttons.forEach(button => {
            if(button.checked) {
                score = score + Number.parseInt(button.value)
            }
        })
        return score;
    }
  }